import React from 'react'
import { LinearProgress, Box, Tabs, Tab, Stack } from '@mui/material'
import axios, { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import { useAuth } from '../../context/useAuth'
import { useSearchParams } from 'react-router-dom'
import SimulationList from './tabs/SimulationList'
import Info from './tabs/Info'
import Generator from './tabs/Generator'

function useSimulations() {
  const { auth, setAuth, getCSRF } = useAuth()
  return useQuery<any, AxiosError>({
    refetchOnWindowFocus: false,
    queryKey: ['simulations'],
    queryFn: async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API}`, {
          withCredentials: true,
        })
        return res.data
      } catch (err: any) {
        const error = err
        if (error.response.status === 401) {
          setAuth({ ...auth, isAuthenticated: false })
          getCSRF()
        }
      }
    },
  })
}

export default function Simulations() {
  const { status, data, isLoading, isFetching } = useSimulations()
  const [searchParams] = useSearchParams()
  const [tab, setTab] = React.useState<string>(searchParams.get('tab') || 'simulations')
  const [simulations, setSimulations] = React.useState<any>([])

  React.useEffect(() => {
    if (data && status === 'success') setSimulations(JSON.parse(data))
  }, [status, data])

  if (isLoading || isFetching) return <LinearProgress />

  return (
    <Stack alignItems={'center'}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
        <Tabs
          sx={{ minHeight: 32 }}
          value={tab}
          onChange={(e, newValue) => {
            setTab(newValue)
            window.history.replaceState(null, '', `?tab=${newValue}`)
          }}
        >
          <Tab label='Simulations' value={'simulations'} />
          <Tab label='Generator' value={'generator'} />
          <Tab label='Info' value={'info'} />
        </Tabs>
      </Box>
      <Stack
        sx={{
          width: '100%',
          py: 0,
        }}
      >
        {tab === 'simulations' && <SimulationList disabled={false} data={simulations} setData={setSimulations} />}
        {tab === 'info' && <Info />}
        {tab === 'generator' && <Generator />}
      </Stack>
    </Stack>
  )
}
